import { exclusionReason } from 'pages/EligibilityCriteria/EligibilityCriteria';
import { getCsrfToken } from 'query';
import { getReviewId } from 'query/review';
import {
  ADD_EXCLUSION_REASON,
  DELETE_EXCLUSION_REASON,
  tokenizeRoute,
} from 'query/routes';

export const deleteExclusionReason = async ({
  reason,
  onApiError,
}: {
  reason: exclusionReason;
  onApiError: (errors: string[] | null) => void;
}) => {
  const reviewId = getReviewId();
  if (!reviewId) {
    onApiError(['Could not determine review ID']);
    return;
  }

  if (!reason) {
    onApiError(['Please provide a reason']);
    return;
  }

  const url = tokenizeRoute(DELETE_EXCLUSION_REASON, {
    review_id: reviewId,
    reason_id: reason?.id,
  });

  return await fetch(url, {
    method: 'DELETE',
    credentials: 'same-origin',
    headers: { 'X-CSRF-Token': getCsrfToken() },
    body: JSON.stringify(reason),
  });
};

export const updateExclusionReason = async ({
  reason,
  onApiError,
}: {
  reason: exclusionReason['reason'];
  onApiError: (errors: string[] | null) => void;
}) => {
  const reviewId = getReviewId();
  if (!reviewId) {
    onApiError(['Could not determine review ID']);
    return;
  }

  if (!reason) {
    onApiError(['Please provide a reason']);
    return;
  }

  const url = tokenizeRoute(ADD_EXCLUSION_REASON, {
    review_id: reviewId,
  });

  return await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': getCsrfToken(),
    },
    body: JSON.stringify({
      exclusion_reason: {
        reason: reason,
      },
      review_id: reviewId,
    }),
  });
};
